import "./footer.scss";
import {Button, Container} from "react-bootstrap";
import axios from "axios";
import {APIResponse, initialState, State} from "../../shared/types/types";
import {CONTACT_US_API_PATH, SERVER_URL} from "../../../global_vars";
import React, {useEffect, useState} from "react";
import {ContactUs} from "../../shared/types/contact-us";

interface SocialImageInfo {
    id: number;
    name: string;
    url: string;
    hoveredImageURL: string;
    defaultImageURL: string;
}

function Footer() {

    const [state, setState] = useState<State>(initialState);
    const [hoveredSocialImageId, setHoveredSocialImageId] = useState<number | null>(null);

    const socialImages = [
        {
            id: 1,
            name: "Facebook",
            url: "https://www.facebook.com/profile.php?id=61567173653170",
            hoveredImageURL: "/Samples/facebook-icon-hover.png",
            defaultImageURL: "/Samples/facebook-icon.png",
        },
        {
            id: 2,
            name: "Instagram",
            url: "https://www.instagram.com/luxora_dubai/",
            hoveredImageURL: "/Samples/instagram-icon-hover.png",
            defaultImageURL: "/Samples/instagram-icon.png",
        },
        {
            id: 3,
            name: "Youtube",
            url: "https://www.youtube.com/",
            hoveredImageURL: "/Samples/youtube-icon-hover.png",
            defaultImageURL: "/Samples/youtube-icon.png",
        },
        {
            id: 4,
            name: "Tik Tok",
            url: "https://www.tiktok.com/",
            hoveredImageURL: "/Samples/tik-tok-icon-hover.png",
            defaultImageURL: "/Samples/tik-tok-icon.png",
        }
    ]


    const [contactUs, setContactUs] = useState<ContactUs>({
        full_name: "",
        email: "",
        message: "",
        phone_number: "",
        consent: false
    });

    const [apiResponse, setApiResponse] = useState<APIResponse>({
        code: 0,
        msg: "",
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const {name, value, type, checked} = event.target as HTMLInputElement;
        setContactUs({
            ...contactUs,
            [name]: type === "checkbox" ? checked : value,
        })
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const contactUsRequest: ContactUs = {
            full_name: contactUs.full_name,
            email: contactUs.email,
            message: contactUs.message.trim(),
            phone_number: contactUs.phone_number,
            consent: contactUs.consent,
        }
        axios.post<APIResponse>(`${SERVER_URL}${CONTACT_US_API_PATH}`, contactUsRequest).then((resp) => {
            return resp.data;
        }).then(data => {
            setApiResponse({
                ...data,
            })
        }).catch((error) => {
            console.log("Error: ", error);
            setState({
                ...state,
                error: error.message,
            })
            setApiResponse({
                ...error.response.data,
            })
        })
    }

    return(
        <footer id="footer">
            <Container fluid className={"container-sticky align-items-center"}>
                <div className={"luxora-footer"}>
                    <div className={"logo"}>
                        <img src={"/Samples/logo-black-big.png"} alt="Luxora Dubai Logo"/>
                    </div>
                    <div className={"info"}>
                        <div className={"info-left"}>
                            <h2>CONTACT US</h2>
                            <div className={"info-sub-info"}>
                                <h4>732.983.7089</h4>
                                <h4>enquiries@luxoradubai.com</h4>
                            </div>
                        </div>
                        <div className={"info-right"}>
                            <h2>ADDRESS</h2>
                            <div className={"info-sub-info"}>
                                <h4>Metropolis Tower, Office Number 215</h4>
                                <h4>Business Bay, Dubai, United Arab Emirates</h4>
                            </div>
                        </div>
                    </div>
                    <div className={"navigation"}>
                        <div className={"website"}>
                            <a href={"/"} className={"website-item"}><span className={"website-item-name"}>HOME</span></a>
                            <a href={"/developer/list"} className={"website-item"}><span className={"website-item-name"}>DEVELOPERS</span></a>
                            <a href={"/property/list"} className={"website-item"}><span className={"website-item-name"}>PROPERTIES</span></a>
                            <a href={"/event/list"} className={"website-item"}><span className={"website-item-name"}>EVENTS</span></a>
                            <a href={"/blog/list?page_num=1"} className={"website-item"}><span className={"website-item-name"}>BLOG</span></a>
                        </div>

                        {/* the urls are temporary */}
                        <div className={"social"}>
                            {
                                socialImages.map((image: SocialImageInfo) => (
                                    <a href={image.url}><img src={image.defaultImageURL}
                                        alt={image.name}
                                    /></a>
                                ))
                            }
                        </div>
                   </div>
                </div>
                {/* <div className={"contact-parallax-overlay"}>
                    <div className={"contact-header"}>
                        <h2>CONTACT US</h2>
                    </div>
                    <div className={"contact-content"}>
                        <div className={"contact-info"}>
                            <h4 className={"contact-info-header"}>CONTACT DETAILS</h4>
                            <div className={"contact-info-item"}>
                                <i className="bi bi-geo-alt contact-info-item-icon"></i>
                                <div className={"contact-info-item-info"}>
                                    <p className={"item"}>ADDRESS</p>
                                    <p className={"item"}>Metropolis Tower, Office Number 215</p>
                                    <p className={"item"}>Business Bay, Dubai, United Arab Emirates</p>
                                </div>
                            </div>
                            <div className={"contact-info-item"}>
                                <i className="bi bi-telephone contact-info-item-icon"></i>
                                <div className={"contact-info-item-info"}>
                                    <p className={"item"}>PHONE</p>
                                    <p className={"item"}>+1 732-983-7089</p>
                                    <p className={"item"}>+971 58 562 7762</p>
                                </div>
                            </div>
                            <div className={"contact-info-item"}>
                                <i className="bi bi-envelope contact-info-item-icon"></i>
                                <div className={"contact-info-item-info"}>
                                    <p className={"item"}>EMAIL</p>
                                    <p className={"item"}>enquiries@luxoradubai.com</p>
                                </div>
                            </div>
                        </div>
                        {
                            apiResponse.code !== 0
                                ?
                                <p className={"status-message"}>{apiResponse.code === 200 ? "Thank you for reaching out to us! We will be in touch with you shortly" : apiResponse.msg.toUpperCase()}</p>
                                :
                                <form className={"contact-form"} onSubmit={handleSubmit}>
                                    <h4 className={"contact-form-header"}>SEND A MESSAGE</h4>
                                    <div className={"contact-form-item"}>
                                        <p className={"contact-form-input-label"}>FULL NAME</p>
                                        <input className={"form-control contact-form-input"} type={"text"}
                                               id="full_name" name="full_name" onChange={handleChange}
                                               required/>
                                    </div>
                                    <div className={"contact-form-item"}>
                                        <p className={"contact-form-input-label"}>EMAIL</p>
                                        <input className={"form-control contact-form-input"} type={"email"}
                                               id="email" name="email" onChange={handleChange}
                                               required/>
                                    </div>
                                    <div className={"contact-form-item"}>
                                        <p className={"contact-form-input-label"}>PHONE NUMBER</p>
                                        <input className={"form-control contact-form-input"} type={"tel"}
                                               id="phone_number" name="phone_number" onChange={handleChange}
                                               required/>
                                    </div>
                                    <div className={"contact-form-item"}>
                                        <p className={"contact-form-input-label"}>MESSAGE</p>
                                        <textarea className={"form-control contact-form-textarea"}
                                                  id="message" name="message" onChange={handleChange}
                                                  rows={5} required></textarea>
                                    </div>
                                    <div className={"contact-form-checkbox-item"}>
                                        <input className={"form-control contact-form-checkbox"} type={"checkbox"}
                                               id="consent" name="consent" onChange={handleChange}
                                               required/>
                                        <p className={"contact-form-checkbox-label"}>
                                            Accept our <a href="/privacy-policy">Privacy Policy</a>
                                        </p>
                                        {/*By providing Luxora with your contact information, you acknowledge and agree to our <a href={"/privacy-policy"}>Privacy Policy</a> and consent to receiving marketing communications, including but not limited to automated calls, texts, and emails. Some of these communications may use artificial or prerecorded voices.*/}
                                        {/*This consent is not required to make any purchases or inquiries about our services, and you may opt out at any time. To stop receiving text messages, simply reply "STOP" at any time. To opt out of emails, click on the unsubscribe link provided in the email.*/}
                                        {/*Message and data rates may apply. Your information will be handled securely and will not be shared with third parties without your consent, except as necessary to provide our services or as required by law.*/}
                                        {/*For more details on how we collect, use, and protect your data, please visit our full Privacy Policy here.*/}
                                    {/* </div>
                                    <div className={"contact-form-item-btn"}>
                                        <Button className={"btn contact-btn"} type="submit">SEND</Button>
                                    </div>
                                </form>
                        }

                    </div>
                </div> */}
            </Container>
        </footer>
    );
}

export default Footer;